// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"46b47927","514":"79e64686"}[chunkId] + ".chunk.js";
};